/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Taxes and fees
 * @export
 * @interface TravelineBookingTaxDto
 */
export interface TravelineBookingTaxDto {
    /**
     * Link to tax description in a booking
     * @type {number}
     * @memberof TravelineBookingTaxDto
     */
    index: number;
    /**
     * Tax name
     * @type {string}
     * @memberof TravelineBookingTaxDto
     */
    name?: string | null;
    /**
     * Tax description
     * @type {string}
     * @memberof TravelineBookingTaxDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the TravelineBookingTaxDto interface.
 */
export function instanceOfTravelineBookingTaxDto(value: object): value is TravelineBookingTaxDto {
    if (!('index' in value) || value['index'] === undefined) return false;
    return true;
}

export function TravelineBookingTaxDtoFromJSON(json: any): TravelineBookingTaxDto {
    return TravelineBookingTaxDtoFromJSONTyped(json, false);
}

export function TravelineBookingTaxDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingTaxDto {
    if (json == null) {
        return json;
    }
    return {
        
        'index': json['index'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

  export function TravelineBookingTaxDtoToJSON(json: any): TravelineBookingTaxDto {
      return TravelineBookingTaxDtoToJSONTyped(json, false);
  }

  export function TravelineBookingTaxDtoToJSONTyped(value?: TravelineBookingTaxDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'index': value['index'],
        'name': value['name'],
        'description': value['description'],
    };
}

